import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Plus: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--plus')}
    data-icon={icon}
    width="12"
    height="11"
    viewBox="0 0 12 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Accordion-Open-Copy" fill="#17171D">
        <path
          d="M6.80842204,4.35301109 L11.1614331,4.35301109 L11.1614331,5.85301109 L6.80842204,5.85301109 L6.80842204,10.2060222 L5.30842204,10.2060222 L5.30842204,5.85301109 L0.955410942,5.85301109 L0.955410942,4.35301109 L5.30842204,4.35301109 L5.30842204,0 L6.80842204,0 L6.80842204,4.35301109 Z"
          id="Plus"
        />
      </g>
    </g>
  </svg>
);

export default Plus;
